import React from 'react';
import { Canvas } from '@react-three/fiber'
import { TrackballControls } from '@react-three/drei'

import { StyledTagsWrapper } from './styled';
import Cloud from './Cloud';

interface ITagsCloudProps {
  children?: React.ReactNode;
}

const TagsCloud:React.FC<ITagsCloudProps> = (props) => {
  return (
    <StyledTagsWrapper>
      <Canvas flat linear dpr={[1, 2]} camera={{ position: [10, 0, 32], fov: 75 }}>
        <fog attach="fog" args={['rgba(0, 0, 0, 0)', 0, 80]} />
        <Cloud count={6} rad={20} />
        {/* @ts-ignore */}
        <TrackballControls />
      </Canvas>
    </StyledTagsWrapper>
  );
}

export default TagsCloud;
